<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="header-modal">
      <h1>Guia de honorários</h1>
    </div>
    <div class="body-modal">
      <form appFormscroll class="form" [formGroup]="model" id="fees-form" (ngSubmit)="submit()">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3">
            @if (listHealthcareAgreement) {
              <app-select-2 [formControlField]="'ansCode'"
                (selectedValue)="onAnsChange($event)" [multiple]="false" [url]="urlListAnsRegistration"
                [idField]="'idHealthcareAgreement'" [nameField]="'ansWithName'"
                [labelField]="'1 - Registro ANS'"
                [preSelectedBlock]="this.idFeesGuide != null ? true : false">
              </app-select-2>
            }
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>2 - Nº da guia no prestador</mat-label>
              <input matInput type="text" formControlName="guideNumber"
                [maxlength]="feesFieldsMaxLengthEnum.guideNumber"
                oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                @if (model.get('guideNumber').invalid) {
                  <mat-error>Preenchimento incorreto</mat-error>
                }
                <mat-hint align="end">{{ model.get('guideNumber').value ?
                  this.model.get('guideNumber').value.length : 0
                }}/{{feesFieldsMaxLengthEnum.guideNumber}}</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>3 - Guia de Internação</mat-label>
                @if (!manualAdmissionGuide) {
                  <mat-select formControlName="admissionGuide"
                    (selectionChange)="onAdmissionGuideChange($event.value)">
                    @for (item of listAdmissionGuide; track item) {
                      <mat-option [value]="item">
                        {{ item.guide.guideNumber }}: <b>{{ item.admissionGuide.datetimeSuggestedAdmission |
                      date:'shortDate'}}</b>
                      -
                      <b>{{item.expectedEndDate | date:'shortDate'}}</b>
                    </mat-option>
                  }
                </mat-select>
              }
              @if (manualAdmissionGuide) {
                <input matInput type="text" [maxlength]="20"
                  formControlName="admissionGuide"
                  oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                }
                @if (model.get('admissionGuide').invalid) {
                  <mat-error>Preenchimento
                  incorreto</mat-error>
                }
                @if (manualAdmissionGuide) {
                  <mat-hint align="end">{{ model.get('admissionGuide').value ?
                    model.get('admissionGuide').value.length : 0
                  }}/{{feesFieldsMaxLengthEnum.admissionGuideNumber}}</mat-hint>
                }
              </mat-form-field>
              <mat-checkbox [(ngModel)]="manualAdmissionGuide" [ngModelOptions]="{standalone:true}"
                (change)="onManualAdmissionSelect($event)" [disabled]="!isEditingAllowed || !this.idHealthcareAgreement">
                Inserir manualmente
              </mat-checkbox>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Status da guia</mat-label>
                <div class="adjust-select">
                  <div class="color-dot" [style.background-color]="guideStatusColor">
                  </div>
                  <div>
                    <mat-select class="select-spacing" formControlName="idGuideStatus" (selectionChange)="onGuideStatusChange($event.value)">
                      @for (item of listGuideStatus; track item) {
                        <mat-option [value]="item.idGuideStatus">
                          <span class="color-dot" [style.background-color]="item.color"></span>
                          {{item.name}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (model.get('idGuideStatus').invalid) {
                      <mat-error>Selecione um status</mat-error>
                    }
                  </div>
                </div>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>4 - Senha</mat-label>
                <input matInput type="text" formControlName="ticket"
                  [maxlength]="feesFieldsMaxLengthEnum.ticket">
                  @if (model.get('ticket').invalid) {
                    <mat-error>Preenchimento incorreto</mat-error>
                  }
                  <mat-hint align="end">{{ model.get('ticket').value ?
                    this.model.get('ticket').value.length : 0
                  }}/{{feesFieldsMaxLengthEnum.ticket}}</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label>5 - N° da Guia na Operadora</mat-label>
                  <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.providerGuideNumber"
                    formControlName="providerGuideNumber"
                    oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                    @if (model.get('providerGuideNumber').invalid) {
                      <mat-error>Preenchimento
                      incorreto</mat-error>
                    }
                    <mat-hint align="end">{{ model.get('providerGuideNumber').value ?
                      model.get('providerGuideNumber').value.length : 0
                    }}/{{feesFieldsMaxLengthEnum.providerGuideNumber}}</mat-hint>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="title-header">
                  <h3>Dados do Beneficiário</h3>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                  <mat-form-field appearance="outline">
                    <mat-label>6 - N° da carteira</mat-label>
                    <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.patientDocumentNumber"
                      formControlName="patientDocumentNumber"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                      @if (model.get('patientDocumentNumber').invalid) {
                        <mat-error>Preenchimento
                        incorreto</mat-error>
                      }
                      <mat-hint align="end">{{ model.get('patientDocumentNumber').value ?
                        model.get('patientDocumentNumber').value.length : 0
                      }}/{{feesFieldsMaxLengthEnum.patientDocumentNumber}}</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>7 - Nome do Beneficiário</mat-label>
                      <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.patientName"
                        formControlName="patientName">
                        @if (model.get('patientName').invalid) {
                          <mat-error>Preenchimento
                          incorreto</mat-error>
                        }
                        <mat-hint align="end">{{ model.get('patientName').value ?
                          model.get('patientName').value.length : 0
                        }}/{{feesFieldsMaxLengthEnum.patientName}}</mat-hint>
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>41 - Nome Social</mat-label>
                        <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.patientSocialName"
                          formControlName="patientSocialName">
                          @if (model.get('patientSocialName').invalid) {
                            <mat-error>Preenchimento
                            incorreto</mat-error>
                          }
                          <mat-hint align="end">{{ model.get('patientSocialName').value ?
                            model.get('patientSocialName').value.length : 0
                          }}/{{feesFieldsMaxLengthEnum.patientSocialName}}</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <mat-form-field appearance="outline">
                          <mat-label>8 - Atendimento a Recém-Nascido</mat-label>
                          <mat-select formControlName="newbornAttendance">
                            <mat-option [value]="true">Sim</mat-option>
                            <mat-option [value]="false">Não</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="title-header">
                        <h3>Dados do Contratado (onde foi executado o procedimento)</h3>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <mat-form-field appearance="outline">
                          <mat-label>Identificação no prestador</mat-label>
                          <mat-select matInput type="text" formControlName="idexecutionStieProviderIdentityType"
                            (selectionChange)="checkExecutantProviderIdentityType($event.value)">
                            @for (item of listProviderIdentityType; track item) {
                              <mat-option
                                [value]="item.idProviderIdentityType">{{item.name}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (model.get('idProviderIdentityType').invalid) {
                            <mat-error>Preenchimento
                            incorreto</mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <mat-form-field appearance="outline">
                          <mat-label>9 - Código na Operadora</mat-label>
                          <input matInput type="text" [maxlength]="executantSiteCodeMaxLength"
                            formControlName="executionSiteProviderCode" [mask]="executerCodeMask"
                            (input)="inputNumber('executionSiteProviderCode')">
                            @if (model.get('executionSiteProviderCode').invalid) {
                              <mat-error>Preenchimento
                              incorreto</mat-error>
                            }
                            <mat-hint align="end">{{ model.get('executionSiteProviderCode').value ?
                              model.get('executionSiteProviderCode').value.length : 0
                            }}/{{executantSiteCodeMaxLength}}</mat-hint>
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <mat-form-field appearance="outline">
                            <mat-label>10 - Nome do Hospital/Local</mat-label>
                            <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.executionSiteName"
                              formControlName="executionSiteName">
                              @if (model.get('executionSiteName').invalid) {
                                <mat-error>Preenchimento
                                incorreto</mat-error>
                              }
                              <mat-hint align="end">{{ model.get('executionSiteName').value ?
                                model.get('executionSiteName').value.length : 0
                              }}/{{feesFieldsMaxLengthEnum.executionSiteName}}</mat-hint>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-6 col-md-3">
                            <mat-form-field appearance="outline">
                              <mat-label>11 - Código CNES</mat-label>
                              <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.executionSiteCnesCode"
                                formControlName="executionSiteCnesCode" (input)="inputNumber('executionSiteCnesCode')">
                                @if (model.get('executionSiteCnesCode').invalid) {
                                  <mat-error>Preenchimento
                                  incorreto</mat-error>
                                }
                                <mat-hint align="end">{{ model.get('executionSiteCnesCode').value ?
                                  model.get('executionSiteCnesCode').value.length : 0
                                }}/{{feesFieldsMaxLengthEnum.executionSiteCnesCode}}</mat-hint>
                              </mat-form-field>
                            </div>
                            <div class="row">
                              <div class="title-header">
                                <h3>Dados do Contratado Executante</h3>
                              </div>
                              <div class="col-12 col-sm-6 col-md-3">
                                <mat-form-field appearance="outline">
                                  <mat-label>Identificação no prestador</mat-label>
                                  <mat-select matInput type="text" formControlName="idProviderIdentityType"
                                    (selectionChange)="checkProviderIdentityType($event.value)">
                                    @for (item of listProviderIdentityType; track item) {
                                      <mat-option
                                        [value]="item.idProviderIdentityType">{{item.name}}
                                      </mat-option>
                                    }
                                  </mat-select>
                                  @if (model.get('idProviderIdentityType').invalid) {
                                    <mat-error>Preenchimento
                                    incorreto</mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12 col-sm-6 col-md-3">
                                <mat-form-field appearance="outline">
                                  <mat-label>12 - Código na Operadora</mat-label>
                                  <input matInput type="text" [maxlength]="requesterCodeMaxLength"
                                    formControlName="executantProviderCode" [mask]="requesterCodeMask"
                                    (input)="inputNumber('executantProviderCode')">
                                    @if (model.get('executantProviderCode').invalid) {
                                      <mat-error>Preenchimento
                                      incorreto</mat-error>
                                    }
                                    <mat-hint align="end">{{ model.get('executantProviderCode').value ?
                                      model.get('executantProviderCode').value.length : 0
                                    }}/{{requesterCodeMaxLength}}</mat-hint>
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>13 - Nome do Contratado</mat-label>
                                    <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.executantName"
                                      formControlName="executantName">
                                      @if (model.get('executantName').invalid) {
                                        <mat-error>Preenchimento
                                        incorreto</mat-error>
                                      }
                                      <mat-hint align="end">{{ model.get('executantName').value ?
                                        model.get('executantName').value.length : 0
                                      }}/{{feesFieldsMaxLengthEnum.executantName}}</mat-hint>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-12 col-sm-6 col-md-3">
                                    <mat-form-field appearance="outline">
                                      <mat-label>14 - Código CNES</mat-label>
                                      <input matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.executantCnesCode"
                                        formControlName="executantCnesCode" (input)="inputNumber('executantCnesCode')">
                                        @if (model.get('executantCnesCode').invalid) {
                                          <mat-error>Preenchimento
                                          incorreto</mat-error>
                                        }
                                        <mat-hint align="end">{{ model.get('executantCnesCode').value ?
                                          model.get('executantCnesCode').value.length : 0
                                        }}/{{feesFieldsMaxLengthEnum.executantCnesCode}}</mat-hint>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="title-header">
                                      <h3>Dados da Internação</h3>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                      <mat-form-field appearance="outline">
                                        <mat-label>15 - Data do Início do Faturamento</mat-label>
                                        <input matInput type="text" [mask]="masks.date" formControlName="billingStartDatetime">
                                        @if (model.get('billingStartDatetime').invalid) {
                                          <mat-error>Data inválida</mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                      <mat-form-field appearance="outline">
                                        <mat-label>16 - Data do Fim do Faturamento</mat-label>
                                        <input matInput type="text" [mask]="masks.date" formControlName="billingEndDatetime">
                                        @if (model.get('billingEndDatetime').invalid) {
                                          <mat-error>Data inválida</mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="title-header">
                                      <h3>Procedimentos realizados</h3>
                                    </div>
                                    <app-fees-procedure-form #feesProcedureFormComponent
                                      (changeProcedure)="calculateTotalFeesValue()" [idFeesGuide]="idFeesGuide"
                                      [disableProcedureEdit]="disableProcedureEdit" [disableProcedureAdd]="disableProcedureAdd"
                                      [accessMap]="accessMap" [techniqueMap]="techniqueMap" [isEditingAllowed]="isEditingAllowed"
                                      [participationDegreeMap]="participationDegreeMap"
                                      [healthcareAgreementStruct]="healthcareAgreementStruct"
                                      [listProfessionalAgreementStruct]="listProfessionalAgreementStruct"
                                      [tussTerminologyGroupMap]="tussTerminologyGroupMap" [listFeesProcedure]="listFeesProcedure"
                                      [cboMap]="cboMap" [tissBilling]="tissBilling" [listState]="this.listState"
                                      [listProfessionalCouncil]="this.listProfessionalCouncil" [idPatient]="this.data.idPatient"
                                      [listFeesRequiredField]="this.listFeesRequiredField">
                                    </app-fees-procedure-form>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <mat-form-field appearance="outline">
                                      <mat-label>37 - Observação/Justificativa</mat-label>
                                      <textarea matInput type="text" [maxlength]="feesFieldsMaxLengthEnum.observations"
                                        formControlName="observations"
                                      oninput="this.value = this.value.replace(/[\n\r]/g, '');"></textarea>
                                      @if (model.get('observations').invalid && !model.get('observations').errors?.maxlength) {
                                        <mat-error
                                          >Preenchimento
                                        incorreto</mat-error>
                                      }
                                      <mat-hint align="end">{{ model.get('observations').value ?
                                        model.get('observations').value.length : 0
                                      }}/{{feesFieldsMaxLengthEnum.observations}}</mat-hint>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-12 col-sm-6 col-md-2">
                                    <mat-form-field appearance="outline">
                                      <mat-label>38 - Valor Total dos Honorários (R$)</mat-label>
                                      <input matInput type="text" formControlName="feesTotalValue" currencyMask
                                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',',allowNegative: 'false' }">
                                        @if (model.get('feesTotalValue').invalid) {
                                          <mat-error>Preenchimento
                                          incorreto</mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                      <mat-form-field appearance="outline">
                                        <mat-label>39 - Data de emissão</mat-label>
                                        <input matInput type="text" [mask]="masks.date" formControlName="datetimeIssue">
                                        @if (model.get('datetimeIssue').invalid) {
                                          <mat-error>Data inválida</mat-error>
                                        }
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div mat-dialog-footer class="footer-modal">
                                    <button mat-flat-button color="accent" class="btn-block" (click)="close()" type="button">
                                      @if (!isLoading) {
                                        <span>Cancelar</span>
                                      }
                                      @if (isLoading) {
                                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                      }
                                    </button>
                                    <button form="fees-form" mat-flat-button color="primary"
                                      class="btn-block" type="submit" [disabled]="!this.isEditingAllowed || !this.idHealthcareAgreement">
                                      @if (!isLoading) {
                                        <span>Salvar</span>
                                      }
                                      @if (isLoading) {
                                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                      }
                                    </button>
                                    @if (this.idGuide && !this.isAttendance) {
                                      <button mat-flat-button color="accent" class="btn-block"
                                        (click)="print()" type="button">
                                        @if (!isLoading) {
                                          <span>Imprimir</span>
                                        }
                                        @if (isLoading) {
                                          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                                        }
                                      </button>
                                    }
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>